import React from 'react';

export default function FlagCell({ value }) {
  if (value) {
    return <span>{value}</span>;
  }
  return <span>-</span>;
}
